import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import RouteWrapper from '../../RouteWrapper';
import HistoricalFlightTrackerSearch from './HistoricalFlightTrackerSearch';
import HistoricalMultiFlight from './HistoricalMultiFlight/container';
import HistoricalFlightTracker from './HistoricalFlightTracker/container';

export default () => (
  <Switch>
    <RouteWrapper
      exact
      path='/historical-flight/search'
      name='HistoricalSearch'
      onEnter={['requireActiveSubscription']}
      component={HistoricalFlightTrackerSearch}
    />
    <RouteWrapper
      exact
      path='/historical-flight/departing/:departureAirportCode/:carrier?'
      name='HistoricalMultiFlight'
      onEnter={['requireActiveSubscription']}
      component={HistoricalMultiFlight}
    />
    <RouteWrapper
      path='/historical-flight/departing/:departureAirportCode/:year?/:month?/:day?/:carrier?'
      component={HistoricalMultiFlight}
      name='HistoricalMultiFlight'
      onEnter={['requireActiveSubscription']}
    />
    <RouteWrapper
      exact
      path='/historical-flight/arriving/:arrivalAirportCode/:carrier?'
      name='HistoricalMultiFlight'
      onEnter={['requireActiveSubscription']}
      component={HistoricalMultiFlight}
    />
    <RouteWrapper
      path='/historical-flight/arriving/:arrivalAirportCode/:year?/:month?/:day?/:carrier?'
      component={HistoricalMultiFlight}
      name='HistoricalMultiFlight'
      onEnter={['requireActiveSubscription']}
    />
    <RouteWrapper
      path='/historical-flight/route/:departureAirportCode/:arrivalAirportCode/:year?/:month?/:day?/:carrier?'
      component={HistoricalMultiFlight}
      name='HistoricalMultiFlight'
      onEnter={['requireActiveSubscription']}
    />
    <RouteWrapper
      path='/historical-flight/:carrier/:flightNumber/:year/:month/:day/:flightId?'
      name='HistoricalFlightTracker'
      component={HistoricalFlightTracker}
      onEnter={['requireActiveSubscription']}
    />
    <Redirect
      from='/historical-flight'
      to='/historical-flight/search'
    />
  </Switch>
);



// WEBPACK FOOTER //
// ./modules/HistoricalFlightStatus/components/routes.js